module.exports = __webpack_public_path__ + "static/section-eight-fa0d6a281f16edf83d7977e662dfd0b0.png";